import { render, staticRenderFns } from "./GameHUD.vue?vue&type=template&id=3dc66b39&scoped=true&"
import script from "./GameHUD.vue?vue&type=script&lang=js&"
export * from "./GameHUD.vue?vue&type=script&lang=js&"
import style0 from "./GameHUD.vue?vue&type=style&index=0&id=3dc66b39&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc66b39",
  null
  
)

export default component.exports